import { create } from 'zustand';
import { EMPTY_VIEW_FILTER, type ViewFilter } from '@/domain/view-filter';
import { registerSessionReset } from './session-reset';

interface ViewFilterState {
  filter: ViewFilter;
  setFilter: (filter: ViewFilter) => void;
  reset: () => void;
}

/** Bộ lọc xem dùng chung cho MỌI màn hình — đổi màn không mất lựa chọn đang lọc. */
export const useViewFilterStore = create<ViewFilterState>((set) => ({
  filter: EMPTY_VIEW_FILTER,
  setFilter: (filter) => set({ filter }),
  reset: () => set({ filter: EMPTY_VIEW_FILTER }),
}));

registerSessionReset(() => useViewFilterStore.getState().reset());
